import theme from '@themes/theme';

export const AVATAR_COLORS = [
  theme.colors.pastelOrange,
  theme.colors.pastelBlue,
  theme.colors.pastelPurple,
  theme.colors.purple,
  theme.colors.greenSecondary,
  theme.colors.pastelMagenta,
];

export const getAvatarColor = (index: number) =>
  AVATAR_COLORS[index % AVATAR_COLORS.length];

export const getInitials = (name: string | null | undefined): string => {
  if (!name) return '?';
  const parts = name.trim().split(' ').filter(Boolean);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

export const truncateName = (
  name: string | null | undefined,
  max = 7
): string => {
  if (!name) return '';
  return name.length <= max ? name : name.slice(0, max) + '...';
};
